/* global globalThis */
export const CONTRACT_PARTY_FIELDS = [
  ["taxId", "CUIT"],
  ["headquartersAddress", "Domicilio legal"],
  ["legalCity", "Localidad"],
  ["legalProvince", "Provincia"],
  ["legalPostalCode", "Codigo postal"],
];
export const TAX_CONDITIONS = [
  ["monotributo", "Monotributista"], ["responsable_inscripto", "Responsable inscripto"],
  ["exento", "Exento"], ["otro", "Otra condicion"],
];
export const REPRESENTATIVE_CAPACITIES = [
  ["titular", "Titular"], ["representante_legal", "Representante legal"], ["apoderado", "Apoderado"],
];
export const CONTRACT_SCOPE_LABELS = [
  ["salonEnabled", "Salon y mesas"], ["deliveryEnabled", "Delivery y retiro"],
  ["waiterEnabled", "Equipo de mozos"], ["stockEnabled", "Stock e ingredientes"],
  ["aiEnabled", "IA / mozo virtual"], ["wePedidosEnabled", "We! pedidos (sujeto a sus condiciones)"],
];
export function createContractRequestId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  if (!globalThis.crypto?.getRandomValues) throw new Error("Abri el registro en un navegador actualizado y con conexion segura.");
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export const isValidContractCuit = (value) => {
  const digits = String(value || "").replace(/[ -]/g, "");
  if (!/^\d{11}$/.test(digits) || /^(\d)\1{10}$/.test(digits)) return false;
  const sum = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2].reduce((total, weight, i) => total + Number(digits[i]) * weight, 0);
  const raw = 11 - sum % 11;
  return Number(digits[10]) === (raw === 11 ? 0 : raw === 10 ? 9 : raw);
};
export function getContractRegistrationError(payload, accepted, authority) {
  const fields = [["legalName", "Nombre o razon social"], ["ownerFullName", "Nombre del representante"],
    ["ownerDocumentId", "Documento del representante"], ["branchAddress", "Domicilio de la sucursal"], ...CONTRACT_PARTY_FIELDS];
  const missing = fields.find(([key]) => !String(payload[key] || "").trim());
  if (missing) return `Completa: ${missing[1]}.`;
  if (!isValidContractCuit(payload.taxId)) return "Revisa el CUIT del restaurante.";
  if (!TAX_CONDITIONS.some(([id]) => id === payload.taxCondition)) return "Selecciona la condicion fiscal.";
  if (!REPRESENTATIVE_CAPACITIES.some(([id]) => id === payload.representativeCapacity)) return "Selecciona en que caracter representas al restaurante.";
  if (!authority) return "Confirma que estas autorizado para representar al restaurante.";
  if (!accepted) return "Lee y acepta el contrato y sus anexos.";
  return "";
}

export function buildRestaurantContractCopy(receipt) {
  const party = receipt.party || {};
  const scope = receipt.scope || {};
  const tax = TAX_CONDITIONS.find(([id]) => id === party.taxCondition)?.[1] || party.taxCondition;
  const capacity = REPRESENTATIVE_CAPACITIES.find(([id]) => id === party.representativeCapacity)?.[1] || party.representativeCapacity;
  const branches = Array.isArray(scope.branches) ? scope.branches : [scope];
  const branchLines = branches.flatMap((branch) => [
    `Sucursal: ${branch.branchName || "Sin nombre"}`, `Domicilio: ${branch.branchAddress || "No registrado"}`,
    `Modalidad: ${branch.serviceMode === "kiosk" ? "Autoservicio / kiosk" : "Restaurante"}`,
    `Modulos: ${CONTRACT_SCOPE_LABELS.filter(([key]) => branch[key]).map(([, label]) => label).join(", ") || "Ninguno informado"}`, "",
  ]);
  return [receipt.title, `Version: ${receipt.version}`, `Constancia: ${receipt.id}`,
    `Aceptado: ${receipt.acceptedAt} (fecha del servidor)`, `Cuenta: ${receipt.actorEmail}`,
    `Identificador de cuenta: ${receipt.actorUserId}`, `SHA-256 del texto: ${receipt.contentSha256}`, "",
    "FICHA DEL RESTAURANTE", `Nombre comercial: ${party.companyName}`, `Nombre o razon social: ${party.legalName}`,
    `CUIT: ${party.taxId}`, `Condicion fiscal: ${tax}`,
    `Domicilio: ${party.headquartersAddress}, ${party.legalCity}, ${party.legalProvince}, CP ${party.legalPostalCode}`,
    `Representante: ${party.ownerFullName}`, `Documento: ${party.ownerDocumentId}`, `Caracter: ${capacity}`,
    `Correo contractual: ${party.notificationEmail}`, "", "ALCANCE AL ACEPTAR", ...branchLines,
    receipt.acceptanceStatement, receipt.authorityStatement,
    "Constancia de aceptacion electronica. No es una firma digital certificada.", "", "TEXTO ACEPTADO", "", receipt.bodyText].join("\n");
}

export async function downloadRestaurantContractCopy(receipt) {
  const { getRestaurantContractPdf } = await import("../supabase/restaurantContractService");
  const blob = await getRestaurantContractPdf(receipt.id);
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url; anchor.download = `Contrato-MozzoApp-${receipt.id}.pdf`;
  document.body.appendChild(anchor); anchor.click(); anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
